module.exports = __webpack_public_path__ + "assets/img/23_137_big.cfc7ed0c.jpg";